var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2842 8.69156V17.0578H2.7168V8.69156C2.7168 7.44098 3.42086 6.35446 4.45523 5.80903C4.90939 5.56782 5.42658 5.43201 5.97635 5.43201H48.0246C49.2752 5.43201 50.3617 6.13607 50.9072 7.17044C51.1484 7.6246 51.2842 8.14179 51.2842 8.69156Z",
    fill: "#00BEBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.755 5.43201V11.5165C15.755 12.1163 15.2682 12.603 14.6685 12.603H9.6705C9.07074 12.603 8.58398 12.1163 8.58398 11.5165V5.43201H15.755Z",
    fill: "#009796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6788 5.43201V11.5165C43.6788 12.1163 43.1921 12.603 42.5923 12.603H37.5943C36.9946 12.603 36.5078 12.1163 36.5078 11.5165V5.43201H43.6788Z",
    fill: "#009796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45523 5.80908V17.0578H2.7168V8.69162C2.7168 7.44103 3.42086 6.35451 4.45523 5.80908Z",
    fill: "#009796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6272 23.5575H17.2174C17.5174 23.5575 17.7606 23.8008 17.7606 24.1008V29.6909C17.7606 29.9909 17.5174 30.2342 17.2174 30.2342H11.6272C11.3273 30.2342 11.084 29.9909 11.084 29.6909V24.1008C11.084 23.8008 11.3273 23.5575 11.6272 23.5575Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6272 31.864H17.2174C17.5174 31.864 17.7606 32.1073 17.7606 32.4073V37.9985C17.7606 38.2985 17.5174 38.5418 17.2174 38.5418H11.6272C11.3273 38.5418 11.084 38.2985 11.084 37.9985V32.4073C11.084 32.1073 11.3273 31.864 11.6272 31.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6272 40.1716H17.2174C17.5174 40.1716 17.7606 40.4149 17.7606 40.7149V46.305C17.7606 46.605 17.5174 46.8483 17.2174 46.8483H11.6272C11.3273 46.8483 11.084 46.605 11.084 46.305V40.7149C11.084 40.4149 11.3273 40.1716 11.6272 40.1716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9339 23.5576H25.6435C25.9435 23.5576 26.1868 23.8009 26.1868 24.1009V29.691C26.1868 29.991 25.9435 30.2343 25.6435 30.2343H19.9339C19.6339 30.2343 19.3906 29.991 19.3906 29.691V24.1009C19.3906 23.8009 19.6339 23.5576 19.9339 23.5576Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9339 31.864H25.6435C25.9435 31.864 26.1868 32.1073 26.1868 32.4073V37.9985C26.1868 38.2985 25.9435 38.5418 25.6435 38.5418H19.9339C19.6339 38.5418 19.3906 38.2985 19.3906 37.9985V32.4073C19.3906 32.1073 19.6339 31.864 19.9339 31.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9339 40.1716H25.6435C25.9435 40.1716 26.1868 40.4149 26.1868 40.7149V46.305C26.1868 46.605 25.9435 46.8483 25.6435 46.8483H19.9339C19.6339 46.8483 19.3906 46.605 19.3906 46.305V40.7149C19.3906 40.4149 19.6339 40.1716 19.9339 40.1716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3597 23.5576H34.0693C34.3693 23.5576 34.6126 23.8009 34.6126 24.1009V29.691C34.6126 29.991 34.3693 30.2343 34.0693 30.2343H28.3597C28.0597 30.2343 27.8164 29.991 27.8164 29.691V24.1009C27.8164 23.8009 28.0597 23.5576 28.3597 23.5576Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3597 31.864H34.0693C34.3693 31.864 34.6126 32.1073 34.6126 32.4073V37.9985C34.6126 38.2985 34.3693 38.5418 34.0693 38.5418H28.3597C28.0597 38.5418 27.8164 38.2985 27.8164 37.9985V32.4073C27.8164 32.1073 28.0597 31.864 28.3597 31.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3597 40.1716H34.0693C34.3693 40.1716 34.6126 40.4149 34.6126 40.7149V46.305C34.6126 46.605 34.3693 46.8483 34.0693 46.8483H28.3597C28.0597 46.8483 27.8164 46.605 27.8164 46.305V40.7149C27.8164 40.4149 28.0597 40.1716 28.3597 40.1716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9188 24.1009V29.691C42.9188 29.991 42.6756 30.2343 42.3756 30.2343H36.7854C36.4855 30.2343 36.2422 29.991 36.2422 29.691V24.1009C36.2422 23.8009 36.4855 23.5576 36.7854 23.5576H42.3756C42.6756 23.5576 42.9188 23.8009 42.9188 24.1009Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7854 31.864H42.3756C42.6756 31.864 42.9188 32.1073 42.9188 32.4073V37.9985C42.9188 38.2985 42.6756 38.5418 42.3756 38.5418H36.7854C36.4855 38.5418 36.2422 38.2985 36.2422 37.9985V32.4073C36.2422 32.1073 36.4855 31.864 36.7854 31.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7854 40.1716H42.3756C42.6756 40.1716 42.9188 40.4149 42.9188 40.7149V46.305C42.9188 46.605 42.6756 46.8483 42.3756 46.8483H36.7854C36.4855 46.8483 36.2422 46.605 36.2422 46.305V40.7149C36.2422 40.4149 36.4855 40.1716 36.7854 40.1716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7168 16.2972V50.7399C2.7168 52.5403 4.17599 53.9995 5.97635 53.9995H48.0246C49.825 53.9995 51.2842 52.5403 51.2842 50.7399V16.2972H2.7168Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7549 1.08627V9.77843C15.7549 10.3782 15.2681 10.8649 14.6683 10.8649H11.4088C10.809 10.8649 10.3223 10.3782 10.3223 9.77843V1.08627C10.3223 0.486516 10.809 -0.000244141 11.4088 -0.000244141H14.6683C15.2681 -0.000244141 15.7549 0.486516 15.7549 1.08627Z",
    fill: "#50758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 23.5575H17.7606V30.2342H11.084V23.5575Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2422 23.5575H42.9188V30.2342H36.2422V23.5575Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3887 23.5575H26.1848V30.2342H19.3887V23.5575Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 31.8638H17.7606V38.5415H11.084V31.8638Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2422 31.8638H42.9188V38.5415H36.2422V31.8638Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3887 31.8638H26.1848V38.5415H19.3887V31.8638Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 40.1714H17.7606V46.848H11.084V40.1714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2422 40.1714H42.9188V46.848H36.2422V40.1714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3887 40.1714H26.1848V46.848H19.3887V40.1714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 23.5575H34.6106V30.2342H27.8145V23.5575Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 31.8638H34.6106V38.5415H27.8145V31.8638Z",
    fill: "#FFAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8145 40.1714H34.6106V46.848H27.8145V40.1714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6787 1.08627V9.77843C43.6787 10.3782 43.1919 10.8649 42.5922 10.8649H39.3326C38.7329 10.8649 38.2461 10.3782 38.2461 9.77843V1.08627C38.2461 0.486516 38.7329 -0.000244141 39.3326 -0.000244141H42.5922C43.1919 -0.000244141 43.6787 0.486516 43.6787 1.08627Z",
    fill: "#50758D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7168 16.2972V50.7399C2.7168 52.5403 4.17599 53.9995 5.97635 53.9995H7.18022C5.66018 53.7235 4.50955 52.3936 4.50955 50.7942V18.6028C4.63233 18.2714 4.95068 18.0357 5.32444 18.0357H51.2842V16.3516V16.2972H2.7168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1472 10.8649H11.4088C10.809 10.8649 10.3223 10.3782 10.3223 9.77843V1.08627C10.3223 0.486516 10.809 -0.000244141 11.4088 -0.000244141H12.0607V9.77843C12.0607 10.3782 12.5475 10.8649 13.1472 10.8649Z",
    fill: "#2B597F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.071 10.8649H39.3326C38.7329 10.8649 38.2461 10.3782 38.2461 9.77843V1.08627C38.2461 0.486516 38.7329 -0.000244141 39.3326 -0.000244141H39.9845V9.77843C39.9845 10.3782 40.4713 10.8649 41.071 10.8649Z",
    fill: "#2B597F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b876bc61a82b4136ac26498cb2536aad.svg";
export { ForwardRef as ReactComponent };